import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const ContactsIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.19971 17.9403L8.34268 17.0259L8.35108 17.0194C8.58937 16.8288 8.70961 16.7326 8.84376 16.6641C8.96412 16.6026 9.09246 16.5578 9.22485 16.5306C9.37408 16.5 9.52953 16.5 9.84155 16.5H16.3523C17.1908 16.5 17.6105 16.5 17.931 16.3367C18.2133 16.1929 18.4429 15.9632 18.5867 15.6809C18.75 15.3604 18.75 14.9411 18.75 14.1027V8.39768C18.75 7.55925 18.75 7.1394 18.5867 6.81885C18.4429 6.5366 18.2128 6.3073 17.9305 6.16349C17.6097 6 17.1902 6 16.3501 6H7.65015C6.81007 6 6.38972 6 6.06885 6.16349C5.7866 6.3073 5.5573 6.5366 5.41349 6.81885C5.25 7.13972 5.25 7.56007 5.25 8.40015V17.0034C5.25 17.8027 5.25 18.2022 5.41384 18.4075C5.55633 18.586 5.77233 18.6898 6.00073 18.6896C6.26336 18.6893 6.57558 18.4396 7.19971 17.9403Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);